/**
 * The KSHEMA payment QR is only usable for 5 minutes (2026-10-22).
 *
 * The automation saves paymentQrScreenshot = { fileName, key, location, expiresAt } - expiresAt is 5 minutes after the QR
 * was made. The server stops handing the picture out after that (or once the policy is Complete / Cancelled) and sends
 * { expired: true, expiredReason } instead; this keeps the page in step with the clock between reloads.
 *
 * A QR saved before expiresAt existed has none: it is shown the old way (a plain document card).
 */
export const FINISHED_STATUSES = ["Complete", "Cancelled"];

/** @returns {number|null} ms since epoch the QR ends, or null when it has no expiry (older policies). */
export const qrEndsAt = (doc) => {
  if (!doc || doc.expiresAt === undefined || doc.expiresAt === null || doc.expiresAt === "") return null;
  const t = new Date(doc.expiresAt).getTime();
  return Number.isNaN(t) ? null : t;
};

/**
 * @param {object} doc          policy.paymentQrScreenshot
 * @param {string} policyStatus policy.status
 * @param {number} now          ms since epoch
 * @returns {{state: "plain"|"live"|"expired"|"completed", remainingMs: number}}
 *   plain = no expiry on it (show as before) - live = counting down - expired / completed = no picture
 */
export const qrState = (doc, policyStatus, now) => {
  const ends = qrEndsAt(doc);
  if (ends === null) return { state: "plain", remainingMs: 0 };
  const remainingMs = Math.max(0, ends - now);
  if (doc.expired && doc.expiredReason === "completed") return { state: "completed", remainingMs: 0 };
  if (doc.expired || remainingMs === 0) return { state: "expired", remainingMs: 0 };
  if (FINISHED_STATUSES.includes(policyStatus)) return { state: "completed", remainingMs: 0 };
  return { state: "live", remainingMs };
};

/** 272000 -> "04:32" */
export const formatCountdown = (ms) => {
  const total = Math.ceil(Math.max(0, ms) / 1000);
  const mm = String(Math.floor(total / 60)).padStart(2, "0");
  const ss = String(total % 60).padStart(2, "0");
  return `${mm}:${ss}`;
};
